import { Component, OnInit } from '@angular/core';
import { User } from '../../../core/models';
import { DomSanitizer, SafeResourceUrl, } from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'app-window-pricing',
  templateUrl: './window-pricing.component.html',
  styleUrls: ['./window-pricing.component.scss']
})
export class WindowPricingComponent implements OnInit {
  url: SafeResourceUrl;
  customerNumber: string;
  public windowPricingToolUrl = environment.windowPricingToolUrl;
  constructor(public sanitizer: DomSanitizer) { }
  userName: string;
  urlSafe: string;
  user: any;
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.userName = this.user.userName;
    this.customerNumber = this.user.customerNumber;
    //this.urlSafe = "https://localhost:44378/ImportExportFile.aspx?userName=" + this.userName;
    //this.urlSafe = "https://www.kawneer-ecommerce.com/wpt/ImportExportFile.aspx?userName=" + this.userName + "&customerNumber=" + this.customerNumber;
    //this.urlSafe = "http://NOATDC-BCSWB912:6083/ImportExportFile.aspx?userName=" + this.userName + "&customerNumber=" + this.customerNumber;
    this.urlSafe = this.windowPricingToolUrl + "?userName=" + this.userName + "&customerNumber=" + this.customerNumber;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlSafe);

  }


}
